var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"app-loader"},[(_vm.brandLogo)?_c('img',{staticClass:"brand-loader",style:({ width: _vm.brandWidth }),attrs:{"src":_vm.brandLogo,"alt":"","aria-hidden":"true"}}):_c('img',{style:({ width: _vm.gifWidth }),attrs:{"src":require("@/assets/loader.gif"),"alt":"","aria-hidden":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }